export { ModalModule } from './modal.module';
export { ModalResult } from './modal.service';
export { ModalColor } from './modal-color';
export { ModalSize } from './modal-size';
